<template>
  <div class="new-user">
    <v-dialog v-model="modal" width="500" persistent>
      <v-card>
            <v-card-title class="title grey lighten-2" primary-title>Add New User</v-card-title>

            <v-card-text class="pt-3">
              
              <v-form ref="form" v-model="valid">

                <v-alert color="red" v-show="isError" dark>{{ errorMessage }}</v-alert>

                <v-text-field v-model="username" :rules="nameRules" label="Username (*)" required></v-text-field>

                <v-text-field v-model="email" :rules="emailRules" label="E-mail (*)" required></v-text-field>

                <v-text-field v-model="password" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required]"
                    :type="show ? 'text' : 'password'"
                    label="Password (*)"
                    @click:append="show = !show"
                    required
                ></v-text-field>

              </v-form>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn dark @click="$emit('close')">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey white--text" :loading="isLoading" :disabled="!valid" @click="addUser">Add User</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { db, functions } from '@/plugins/appfirebase'

export default {

  data: () => ({
    
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
          required: value => !!value || 'Required.'
      },
      valid: true,
      show: false,
      isLoading: false,

      username: '',
      email: '',
      password: '',
      modal: true,
      isError: false,
      errorMessage: ''

  }),

  methods: {

    addUser() {

      if (this.valid) {

          this.isLoading = true
          const addNewUser = functions.httpsCallable('addNewUser');

          addNewUser({ username: this.username , email: this.email , password: this.password }).then( result => {

                  if (result.data.errorInfo) { 
                    this.isError = true; 
                    this.isLoading = false;
                    this.errorMessage = result.data.errorInfo.message;
                  } else { 

                    db.collection('users').doc(result.data.uid).set({ username: this.username, password: this.password, lock: true })
                    .then(() => { 
                      this.isLoading = false
                      this.$emit('close')
                      location.reload();  
                    })
                    
                  }
                
            })
      }

    }

  },

}
</script>

<style>

</style>